import gql from 'graphql-tag';

const GET_NEXXEN_LINE_ITEMS = gql`
  query nexxenLineItems($insertionOrderId: String!) {
    nexxenLineItems(insertionOrderId: $insertionOrderId) {
      id
      name
      status
      packageId
      insertionOrderId
      advertiserId
      budget {
        pacing
        schedules {
          startDate
          endDate
          budget
        }
      }
      bidding {
        bids
      }
    }
  }
`;

export default GET_NEXXEN_LINE_ITEMS;
